import { Component, OnInit, ViewChild } from '@angular/core';
import { indexOf, filter, isArray, forEach, startsWith } from 'lodash';
import { PlatfromUserAccssManagementService } from '../../services/platform-user-access-management.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CreateUserCommand, CountryCode } from '../../models/platform-user-access-management.model';
import { Location } from '@angular/common';
import { first, take } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ShellDomainProvider } from '../../../core';
import { AppProfileImageDialogComponent } from '../../dialogs/app-profile-image-dialog/app-profile-image-dialog.component';
import { UAMProfileImageUploadService } from '../../services/platform-profile-image-upload.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ValidationService } from '../../../app-platform-front-end-validation';

@Component({
    selector: 'app-platform-user-create',
    templateUrl: './platform-user-create.component.html',
    styleUrls: ['./platform-user-create.component.scss'],
    standalone: false
})
export class PlatformUserCreateComponent implements OnInit {
    roleList: any;
    rootPath: string;
    userId: any;
    isCheckedTwoFactor: boolean = true;
    seletedRole: any;
    isMultipleRole: false;
    userInfo: any = {};
    defaultRoles: any = ['appuser', 'anonymous'];
    emailAvailable: boolean = true;
    validEmail: boolean = true;
    defaultCountryOfPhoneNumber: string = 'bd';
    allowedCountriesOfPhoneNumber: any;
    loading: boolean = false;
    uamViews: any;
    uamConfig: any;
    profileImageFile: any;
    paramsSubscription: any;
    gender: any = ['Male', 'Female'];
    salutation: any = ['Mr', 'Mrs'];
    profileImageFileUrl: any;
    ProfileImageUrl: any;
    updateProfileImage: boolean = false;
    profileDefaultImageUrl: string =
        ShellDomainProvider['api'].CdnBaseUrl + 'swica/assets/images/profile-default-1.svg';
    @ViewChild('liveBookingSlideToggle', { static: true }) liveBookingSlideToggle: any;
    @ViewChild('profileImage', { static: true }) profileImageElem: any;
    constructor(
        private platfromUserAccssManagementService: PlatfromUserAccssManagementService,
        private router: Router,
        private _location: Location,
        private snackBar: MatSnackBar,
        private translateService: TranslateService,
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog,
        private UAMProfileImageUploadService: UAMProfileImageUploadService,
        private domSanitizer: DomSanitizer
    ) {
        this.userInfo = new CreateUserCommand();
        let countries = new CountryCode();
        // this.allowedCountriesOfPhoneNumber = countries && countries.countryCode;
    }

    ngOnInit() {
        this.uamViews = this.platfromUserAccssManagementService.getViews();
        this.uamConfig = this.platfromUserAccssManagementService.getUamConfig();
        this.updateProfileImage =
            (this.uamConfig &&
                this.uamConfig.ProfileImageConfig &&
                this.uamConfig.ProfileImageConfig.UpdateProfileImage) ||
            false;
        if (this.uamConfig && this.uamConfig.ProfileImageConfig && this.uamConfig.ProfileImageConfig.DefaultImageUrl) {
            this.profileDefaultImageUrl = this.uamConfig.DefaultImageUrl;
        }
        this.getRoles();
        // this.activatedRoute.params.subscribe(params => {
        //     this.userId = params && params["userId"];
        //     this.getRoles();
        // });
        // this.paramsSubscription =  this.activatedRoute.queryParams.subscribe(params => {
        //     this.rootPath = params && params['root'];
        // });
    }
    getRoles() {
        this.platfromUserAccssManagementService.getUsersRoles([]).subscribe(responseRoles => {
            let filterRoles = filter(responseRoles && responseRoles.Roles, role => {
                if (indexOf(this.defaultRoles, role.RoleName) == -1) return role;
            });
            this.roleList = filterRoles;
        });
    }

    onSelectionChange(role) {
        this.seletedRole = role && role.value;
    }
    getUpdateUser() {
        if (isArray(this.seletedRole)) {
            this.userInfo.Roles = [];
            forEach(this.seletedRole, role => {
                this.userInfo.Roles.push(role.RoleName);
            });
        } else {
            this.userInfo.Roles = [];
            this.userInfo.Roles.push(this.seletedRole && this.seletedRole.RoleName);
        }
        forEach(this.defaultRoles, role => {
            indexOf(this.userInfo && this.userInfo.Roles, role) > -1 ? null : this.userInfo.Roles.push(role);
        });
        this.userInfo.PhoneNumber = this.getValidPhoneNumber();
        return this.userInfo;
    }

    getValidPhoneNumber() {
        if (this.userInfo.PhoneNumber) {
            if (startsWith(this.userInfo.PhoneNumber, '+')) return this.userInfo.PhoneNumber;
            else {
                return '+' + this.userInfo.PhoneNumber;
            }
        }
    }
    public validateEmail() {
        let isValidEmail = ValidationService.isValidEmail(this.userInfo && this.userInfo.Email);
        this.emailAvailable = true;
        if (isValidEmail) {
            this.validEmail = true;
        } else {
            this.validEmail = false;
        }
    }
    isEmailExist() {
        this.validateEmail();
        if ((this.userInfo && !this.userInfo.Email) || !this.validEmail) return;
        this.platfromUserAccssManagementService
            .isEmailExist(this.userInfo && this.userInfo.Email)
            .subscribe(response => {
                this.emailAvailable = response && response.IsAvailable; /// IsAvailable== true for able to create and false for not allowed to create
            });
    }
    createuser() {
        this.loading = true;
        let validUserInfo = this.platfromUserAccssManagementService.updateUserWithPersonInfo(this.getUpdateUser());
        this.platfromUserAccssManagementService.createUser(validUserInfo).subscribe(response => {
            if (this.profileImageFile) {
                this.UAMProfileImageUploadService.uploadProfileImageOfUser(
                    validUserInfo,
                    this.profileImageFile,
                    this.uamConfig
                ).subscribe(response => {
                    this.loading = false;
                    this.routeToUserList();
                });
            } else {
                this.loading = false;
                this.routeToUserList();
            }
        });
    }
    routeToUserList() {
        this._location.back();
        // this.router.navigate([this.rootPath]);
    }

    setTwofactorAuthentication() {
        this.userInfo.TwoFactorEnabled = !this.userInfo.TwoFactorEnabled;
        this.showMessage();
    }
    showMessage() {
        this.translateService
            .get('UPDATE_TWO_FACTOR_AUTHENTICATION')
            .pipe(take(1))
            .subscribe((message: string) => {
                if (message !== 'UPDATE_TWO_FACTOR_AUTHENTICATION') {
                    this.snackBar.open(message, null, { duration: 1000 });
                }
            });
    }

    openProfileImageDialog() {
        const dialogRef = this.dialog.open(AppProfileImageDialogComponent, {
            panelClass: 'swica-dialog',
            width: '100vw',
            maxWidth: '550px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(profileImage => {
            if (profileImage) {
                this.profileImageFile = profileImage;
                this.profileImageFileUrl = window.URL.createObjectURL(this.profileImageFile);
                document.querySelector('#image')['style']['background-image'] = 'url(' + this.profileImageFileUrl + ')';
            }
        });
    }

    ngOnDestroy(): void {
        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe();
        }
    }
}
